const dateFormat = require('dateformat');
import { constants } from '../../utils/constants';
import english from '../../lib/lang/english';
import french from '../../lib/lang/french';

const { LANGUAGES } = constants;
const TRANSLATED_ROUTES = ["FillForm", "ViewForm", "WaitForPDF", "PaymentRedirect"]

export default {
    namespaced: true,
    state: {
        language: localStorage.getItem('language'),
    },
    getters: {
        language(state, getters, rootState, rootGetters) {
            if (!TRANSLATED_ROUTES.includes(rootGetters['base/currentRoute'].name))
                return 'en';
            if (state.language) return state.language;
            const queryLang = rootGetters['base/currentRoute'].query.l;
            if (queryLang && LANGUAGES.find((lang) => lang.code === queryLang)) {
                localStorage.setItem('language', queryLang);
                return queryLang;
            }
            return rootGetters['package/language'];
        },
        tr(state, getters) {
            switch (getters.language) {
                case 'fr':
                    return french;
                case 'en':
                default:
                    return english;
            }
        },
        dateFormat: (state, getters) => (date, format) => {
            // Returns a localized date format
            // Only one language can be loaded in dateformat at a time, so we have to change the localization
            // on the fly, and reset it after doing the format to not affect regular dateFormat()s
            const tr = getters.tr;
            const original = { ...dateFormat.i18n };
            if (tr.dayNames) dateFormat.i18n.dayNames = tr.dayNames;
            if (tr.monthNames) dateFormat.i18n.monthNames = tr.monthNames;
            if (tr.timeNames) dateFormat.i18n.timeNames = tr.timeNames;
            const formatted = dateFormat(date, format);
            dateFormat.i18n.dayNames = original.dayNames;
            dateFormat.i18n.monthNames = original.monthNames;
            dateFormat.i18n.timeNames = original.timeNames;
            return formatted;
        },
    },
    mutations: {
        language(state, language) {
            localStorage.setItem('language', language);
            state.language = language;
        },
    },
    actions: {}
}